module.exports = __webpack_public_path__ + "img/real-pay-success.b7c6d99d.png";